import React from 'react';
import './DocumentLinks.css';

import Icon from '../Icon/Icon';

const documentLinks = ( props ) => {
	let docLinks = null;
	
	if( props.docs ) {
		docLinks = props.docs.map( doc => (
			<a key={ doc.id } className="document" href={ doc.link }>
				<Icon icon="doc" title={ doc.title } />
				<span className="document-title">{ doc.title }</span>
			</a>
		));
	}
	
	return (
		<div className="downloads">
			{ docLinks }
		</div>
	);
};

export default documentLinks;



// WEBPACK FOOTER //
// ./src/components/DocumentLinks/DocumentLinks.js